import { type MouseEvent } from "react";
import { type ShopfrontDispatch } from "../../_Bootstrap/hooks";
import { store } from "../../_Bootstrap/RoutingAndStore";
import { hideDialog, showDialog } from "../../Actions/Dialogs/DialogActions";
import { startLoading } from "../../Actions/General/LayoutActions";
import { databaseBlocked } from "../../Actions/Information/InformationActions";
import { CancelOptionButton } from "../../Common/Buttons/Button";
import { performRefreshAcrossTabs } from "../../Common/Misc/DatabaseBlocked";
import PopupManager from "../../Common/Popups/PopupManager";
import { IndexedDatabase } from "./Database";
import { setDatabaseNeedsUpdating, setDataSource } from "./DataSource";

export const createDatabaseVersionPopup = (forceAllRefresh: boolean): void => {
    const id = "database-version-outdated";

    setDatabaseNeedsUpdating();
    PopupManager.create({
        id,
        message: (
            <a
                href="#"
                onClick={(e: MouseEvent): void => {
                    e.preventDefault();

                    if(forceAllRefresh) {
                        (store.dispatch as ShopfrontDispatch)(showDialog(
                            "Update Required",
                            <p>
                                Shopfront requires all pages to refresh for this update to work, make sure you save
                                changes on any other open tab before continuing.
                            </p>,
                            "warning",
                            [ CancelOptionButton, {
                                label   : "Refresh",
                                classes : [ "button-warning" ],
                                callback: () => {
                                    (store.dispatch as ShopfrontDispatch)(hideDialog());
                                    setTimeout(() => {
                                        store.dispatch(startLoading());
                                    }, 100);

                                    void performRefreshAcrossTabs();
                                },
                            }]
                        ));

                        return;
                    }

                    window.location.reload();
                }}
            >
                A new version of Shopfront is now available and this page requires a refresh,
                please click here when you can to refresh the page. Some parts of the POS system
                may not work properly until this is done on each open tab.
            </a>
        ),
        icon   : "exclamation",
        classes: [ "popup-warning" ],
        timeout: 0,
    });
};

const showBlockedDatabase = (certainItIsBlocked: boolean) => {
    setDatabaseNeedsUpdating();
    store.dispatch(databaseBlocked(certainItIsBlocked));
};

const db = new IndexedDatabase(
    createDatabaseVersionPopup,
    showBlockedDatabase
);

setDataSource(db.initialised);
